import React from 'react'
import { Modal } from 'react-bootstrap'

export default function MessageDetails(props) {

    const { msgDetailsModal, setMsgDetailsModal, replyData, setReplyData } = props
    // console.log(replyData)

    const handleClose = () => {
        setMsgDetailsModal(false)
        setReplyData()
    }

    return (
        <>
            <Modal
                show={msgDetailsModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Message Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <span style={{ color: '#9d9d9d' }}>Title</span>
                    <h6>{replyData && replyData.title}</h6>

                    <span style={{ color: '#9d9d9d' }}>Description</span>
                    <h6>{replyData && replyData.description}</h6>

                    <span style={{ color: '#9d9d9d' }}>Reply</span>
                    <h6>{replyData && replyData.answer}</h6>

                    <hr className='hr_line' />

                    <div className="d-flex justify-content-between align-items-baseline">
                        <span style={{ color: '#9d9d9d' }}>Learning Module Title</span>
                        <h6>{replyData && replyData.course_name}</h6>
                    </div>

                    <div className="d-flex justify-content-between align-items-baseline">
                        <span style={{ color: '#9d9d9d' }}>Ask By</span>
                        <h6>{replyData && replyData.ask_by_nc}</h6>
                    </div>

                    <div className="d-flex justify-content-between align-items-baseline">
                        <span style={{ color: '#9d9d9d' }}>Reply By</span>
                        <h6>{replyData && replyData.ans_by_nc}</h6>
                    </div>

                    <div className="d-flex justify-content-between align-items-baseline">
                        <span style={{ color: '#9d9d9d' }}>Created On</span>
                        <h6>{replyData && replyData.createdAt}</h6>
                    </div>

                </Modal.Body>
                {/* <Modal.Footer>
                    <Button type='submit' variant="primary" className='btn_submit'>Submit</Button>
                </Modal.Footer> */}

            </Modal>
        </>
    )
}
